import { data } from 'jquery';
import url, { get, post, del, put, getUrl, delUrl } from '../http'

// 知识产权质量评价人员采集接口
// export const getInfo = data => post('/v1/api/patentPerson/savePatentQualityPersonnel', data); 
export const getInfo = data => post('/v1/api/patentPerson/zhiLiangTiShengFuDaoRenYuanCaiJi', data); 
// http://localhost:8082/imspp-qualification/v1/api/file
export const getPicture = data => post('/v1/api/file', data); 
// 行业接口

export const getIndustry = () => get('/v1/basicdata/getIndustryList'); //行业分类接口
// 资质等级
export const getDict = () => get('/v1/basicdata/getDictList?dictCode=ZZDJ');